import React from 'react';
import { Graph } from '../types';
import { CommandManager } from '../commands';
import withContext from './withContext';

export interface EditorContextProps {
  graph: Graph | null;
  executeCommand: (name: string, params?: Record<string, unknown>) => void;
  commandManager: CommandManager;
}

export interface EditorPrivateContextProps {
  setGraph: (graph: Graph) => void;
  commandManager: CommandManager;
}

export const EditorContext = React.createContext({} as EditorContextProps);
export const EditorPrivateContext = React.createContext({} as EditorPrivateContextProps);

export const withEditorContext = withContext<EditorContextProps>(
  EditorContext,
  (context) => !!context.graph,
);
export const withEditorPrivateContext =
  withContext<EditorPrivateContextProps>(EditorPrivateContext);
